import camelCase from 'lodash/camelCase.js'
import lowerCase from 'lodash/lowerCase.js'
import startCase from 'lodash/startCase.js'
import upperFirst from 'lodash/upperFirst.js'
import compose from './compose.js'

export const pascalCase = compose(upperFirst, camelCase)

export const titleCase = compose(startCase, lowerCase)

export const sentenceCase = compose(upperFirst, lowerCase)

export const ellipsis = (length, str) => {
  if (!str) {
    return ''
  }
  if (str.length <= length) {
    return str
  }
  const maxStr = str.substr(0, length + 1)
  return maxStr.lastIndexOf(' ') > -1
    ? maxStr.substring(0, maxStr.lastIndexOf(' ')) + '…'
    : maxStr + '…'
}

export const formatHtmlString = (renderItalic, renderParagraph) => {
  const wrapItalics = (string, i) => {
    // strip remaining html
    string = string.replace(/<br ?\/?>/g, ' ').replace(/<[^>]*>/g, '')
    // wrap in italics
    return i % 2 === 0 ? string : renderItalic(string, i)
  }

  const wrapParagraph = (string, i) => {
    const textElements = string.split(/<\/?(?:i|em)>/g).map(wrapItalics)
    return renderParagraph(textElements, i)
  }

  return (string) => string.split(/<br ?\/?><br ?\/?>/g).map(wrapParagraph)
}

export const formatMarkdownItalics = (renderItalic) => (markdown) =>
  markdown
    ? markdown.split(/\*+/g).map((string, i) => (i % 2 === 0 ? string : renderItalic(string, i)))
    : ''
